import React, { useState } from "react";
import EditPublication from "./EditPublication";

// Publication dates arrive as date-only strings ("2023-06-01") or as the API's UTC-stamped timestamps;
// either way "2023-06-01" parses as UTC midnight, so format in UTC or every viewer west of Greenwich
// reads the date a day early. Anything unparseable is shown as-is rather than as "Invalid Date".
function formattedDate(value) {
  if (!value) {
    return null;
  }

  const options = { month: "short", day: "numeric", year: "numeric", timeZone: "UTC" };
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, options);
}

// A single publications row — read mode shows the outlet name/title/dates with edit + remove controls;
// edit mode swaps in the row editor. Mirrors pr_profiles' EditEmploymentLine.
function EditPublicationLine({ mediaJob, onChange, onRemove, disabled = false }) {
  const [editing, setEditing] = useState(false);

  const toggleEditing = () => {
    setEditing((prev) => !prev);
  };

  const confirmEditing = (updatedMediaJob) => {
    setEditing(false);
    onChange(updatedMediaJob);
  };

  return editing ? (
    <EditPublication mediaJob={mediaJob} onConfirm={confirmEditing} onCancel={toggleEditing} disabled={disabled} />
  ) : (
    <tr>
      <td>{mediaJob.mediaOutletName}</td>
      <td>{mediaJob.title}</td>
      <td>{formattedDate(mediaJob.from)}</td>
      <td>{formattedDate(mediaJob.to)}</td>
      <td className="text-nowrap">
        <div className="d-flex">
          <button
            onClick={toggleEditing}
            type="button"
            className="btn btn-sm btn-outline-primary d-flex"
            aria-label="Edit"
            disabled={disabled}
          >
            <i className="fas fa-edit" />
          </button>
          &nbsp;
          <button
            onClick={onRemove}
            type="button"
            className="btn btn-sm btn-outline-secondary d-flex"
            aria-label="Remove"
            disabled={disabled}
          >
            <i className="fas fa-trash text-destructive-90" />
          </button>
        </div>
      </td>
    </tr>
  );
}

export default EditPublicationLine;
